export const useCheckboxesToggler = {
  emits: ["choose", "close"],
  props: {
    onlyIds: {
      type: Boolean,
      default: false,
    },
    alreadyAddedFields: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectorFieldName: "name",
      choosedFields: [],
    };
  },
  computed: {
    allFieldsWereAdded() {
      const listLength =
        this.fieldsList.length - this.addedFieldsSelectors.length;
      return !!(this.choosedFields.length === listLength);
    },
    addedFieldsSelectors() {
      let selectors = [];
      this.alreadyAddedFields.forEach((field) => {
        selectors.push(field[this.selectorFieldName]);
      });
      return selectors;
    },
  },
  methods: {
    handleAllCheckboxes() {
      if (!this.allFieldsWereAdded) {
        return this.addAll();
      }
      this.choosedFields = [];
    },
    addAll() {
      this.choosedFields = [];
      this.fieldsList.forEach((field) => {
        const selector = field[this.selectorFieldName];
        const alreadyAdded = this.addedFieldsSelectors.includes(selector);
        if (!alreadyAdded) {
          this.choosedFields.push(this.onlyIds ? field.id : field);
        }
      });
    },
    confirmChoice() {
      this.$emit("choose", this.choosedFields);
      this.close();
    },
    close() {
      if (this.searchData) {
        this.searchData = "";
      }
      document.querySelector("body").style.overflow = "auto";
      this.choosedFields = [];
      this.$emit("close");
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useCheckboxesToggler.js